import MuiButton from './MuiButton';
import MuiChip from './MuiChip';
import MuiCssBaseline from './MuiCssBaseline';
import MuiDataGrid from './MuiDataGrid';
import MuiFilledInput from './MuiFilledInput';
import MuiFormControl from './MuiFormControl';
import MuiFormLabel from './MuiFormLabel';
import MuiLink from './MuiLink';
import MuiLinearProgress from './MuiLinearProgress';
import MuiMobileStepper from './MuiMobileStepper';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaginationItem from './MuiPaginationItem';
import MuiPickersDay from './MuiPickersDay';
import MuiSelect from './MuiSelect';
import MuiStepper from './MuiStepper';
import MuiTab from './MuiTab';
import MuiTable from './MuiTable';
import MuiTableCell from './MuiTableCell';
import MuiTableContainer from './MuiTableContainer';
import MuiTablePagination from './MuiTablePagination';
import MuiTableRow from './MuiTableRow';
import MuiTextField from './MuiTextField';
import MuiToolbar from './MuiToolbar';
import MuiTooltip from './MuiTooltip';
import MuiFormHelperText from './MuiFormHelperText';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiInputLabel from './MuiInputLabel';
import MuiAccordion from './MuiAccordion';
import MuiAlert from './MuiAlert';
import MuiPaper from './MuiPaper';
import MuiRadio from './MuiRadio';
import MuiAutocomplete from './MuiAutocomplete';
import MuiSvgIcon from './MuiIcon';
import MuiSwitch from './MuiSwitch';
import MuiStack from './MuiStack';
import MuiIconButton from './MuiIconButton';
import MuiBadge from './MuiBadge';
import MuiTimeline from './MuiTimeline';
import MuiDrawer from './MuiDrawer';
import MuiListItemButton from './MuiListItemButton';
import MuiGrid from './MuiGrid';
import MuiMenuItem from './MuiMenuItem';
import MuiCheckbox from './MuiCheckbox';

const components = {
  MuiButton,
  MuiChip,
  MuiCssBaseline,
  MuiDataGrid,
  MuiFilledInput,
  MuiFormControl,
  MuiFormLabel,
  MuiLink,
  MuiLinearProgress,
  MuiMobileStepper,
  MuiOutlinedInput,
  MuiPaginationItem,
  MuiPickersDay,
  MuiSelect,
  MuiStepper,
  MuiTab,
  MuiTable,
  MuiTableCell,
  MuiTableContainer,
  MuiTablePagination,
  MuiTableRow,
  MuiTextField,
  MuiToolbar,
  MuiTooltip,
  MuiFormHelperText,
  MuiFormControlLabel,
  MuiInputLabel,
  MuiAccordion,
  MuiAlert,
  MuiPaper,
  MuiRadio,
  MuiAutocomplete,
  MuiSvgIcon,
  MuiSwitch,
  MuiStack,
  MuiIconButton,
  MuiBadge,
  MuiTimeline,
  MuiDrawer,
  MuiListItemButton,
  MuiGrid,
  MuiMenuItem,
  MuiCheckbox,
};

export default components;
